module.exports = __webpack_public_path__ + "img/speaker5.6ef70987.png";